import {
  FusionClass
} from './core/bridge';

// if (window.Fusion) {
//   throw new Error('Fusion has existed! You can ignore this error.');
// }

/* eslint-disable no-undef */
var Fusion = new FusionClass('1.0.6');
Fusion.fetchJSModules();

export default Fusion;
// module.exports = Fusion;



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/fusion.js